module.exports = __webpack_public_path__ + "media/images/border-7a275b01e4b1065631550278fac07dc0.png";